import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { LogService } from '../../../_shared/log.service'
import { SemesterService } from '@app/_services/masters/semester.service';
import { first } from 'rxjs/operators';
import { semester } from '@app/_models/semester';
import { Subject } from 'rxjs';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-semester-master',
  templateUrl: './semester-master.component.html',
  styleUrls: ['./semester-master.component.css']
})
export class SemesterMasterComponent implements OnInit {
 
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
  @ViewChild('showModalDeleteBox', { read: TemplateRef }) showModalDeleteBoxTemplate: TemplateRef<any>;

  getresponse: any;
  semester: semester[];
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  semesterId: number;
  delMessage: string;

  constructor(private modalService: NgbModal, config: NgbModalConfig, private eventService: LogService, private semesterService: SemesterService) { }

  callRoute(dataValue) {
    this.eventService.emit<string>(dataValue);
  }

  passData(dataValue, data) {
    this.eventService.emit({ dataValue, data });
  }

  ngOnInit(): void {

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true
    };
    this.semesterService.getSemester()
      .pipe(first())
      .subscribe(
        data => {
          console.log("semester response---", data)
          this.semester = data.respData;
          this.dtTrigger.next();
        },
        error => {
          console.log(error)
        }
      )
  }



  refresh(): void {
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>('21');
  }

  deleteSemester(id) {
    this.semesterId = id;
    this.modalService.open(this.showModalDeleteBoxTemplate);
  }

  deleteSem() {
    this.semesterService.deleteSemester(this.semesterId)
      .pipe(first())
      .subscribe(
        data => {
          console.log("semester response---", data)
          this.getresponse = data;

          if (this.getresponse.respMessage == "Success") {
            this.modalService.dismissAll(this.showModalDeleteBoxTemplate);
            this.modalService.open(this.showModalBoxTemplate);
            this.semesterService.getSemester()
              .pipe(first())
              .subscribe(
                data => {
                  this.delMessage="Semester Deleted Successfully."
                  console.log("semester response---", data)
                  this.semester = data.respData;
                  //this.dtTrigger.next();
                },
                error => {
                  console.log(error)
                }
              )
          }
          else if (this.getresponse.respMessage == "Failure") {
            this.delMessage=this.getresponse.respData
            this.modalService.dismissAll(this.showModalDeleteBoxTemplate);
            this.modalService.dismissAll(this.showModalBoxTemplate);
          }
        },
        error => {
          console.log(error)
        }
      )
  }
}
